import * as React from 'react'

export default () => (
  <svg width="71" height="71" viewBox="0 0 71 71" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="27.25" y="22.25" width="17.5" height="27.5" rx="8.75" stroke="#3C52EF" strokeWidth="1.5" />
    <rect x="33.5" y="27.25" width="5" height="10" rx="2.5" fill="#3C52EF" />
  </svg>
)
